/* eslint-disable react/prop-types */
import React, { createContext } from 'react';
import { ConfigProvider, theme } from 'antd';
import useLocalStorage from '../hooks/useLocalStorage';

const SettingContext = createContext();
const colors = {
  background_color_dark: '#24292D',
  background_color_lightdark: '#272E36',
  background_color_exlightdark: '#2b333c',
  primary_color: '#009ccd',
  color_light_01: 'rgba(255,255,255,.01)',
  color_light_02: 'rgba(255,255,255,.02)',
  color_light_03: 'rgba(255,255,255,.03)',
  color_light_05: 'rgba(255,255,255,.05)',
  color_light_1: 'rgba(255,255,255,.1)',
  color_light_2: 'rgba(255,255,255,.2)',
  color_light_3: 'rgba(255,255,255,.3)',
  color_light_4: 'rgba(255,255,255,.4)',
};
const baseTheme = {
  cssVar: true,
  hashed: false,
};

//十六进制颜色转换为带透明度的格式
const hexToRGBA = (hex, alpha = 1) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const apptheme = ({ dark, primaryColor, borderRadius }) => {
  if (dark) {
    return {
      ...baseTheme,
      algorithm: theme.darkAlgorithm,
      token: {
        colorPrimary: primaryColor,
        borderRadius,
        Layout: {
          bodyBg: colors.background_color_dark,
          footerBg: colors.background_color_dark,
          headerBg: colors.background_color_lightdark,
          siderBg: colors.background_color_lightdark,
          triggerBg: colors.background_color_lightdark,
          algorithm: false, // 启用算法
        },
        Card: {
          colorBgContainer: colors.background_color_lightdark,
          colorBorderSecondary: colors.color_light_03,
        },
        Input: {
          colorBgContainer: 'transprent',
          colorBorder: colors.color_light_1,
        },
        Button: {
          colorBgContainer: colors.background_color_lightdark,
          colorBorder: colors.color_light_1,
          colorLink: primaryColor,
          defaultGhostColor: colors.color_light_3,
          defaultGhostBorderColor: colors.color_light_1,
        },
        Table: {
          colorBgContainer: 'transprent',
          headerBg: 'transprent',
          borderColor: colors.color_light_1,
          colorTextHeading: colors.color_light_4,
          rowHoverBg: colors.color_light_02,
          colorLink: primaryColor,
          colorPrimary: primaryColor,
        },
        Select: {
          colorBgContainer: 'transprent',
          colorBgElevated: colors.background_color_lightdark,
          optionSelectedBg: 'rgba(255,255,255,.05)',
          colorBorder: colors.color_light_1,
        },
        Pagination: {
          colorBgContainer: 'transprent',
        },
        Dropdown: {
          colorBgElevated: colors.background_color_exlightdark,
        },
        Typography: {
          colorLink: primaryColor,
          colorPrimary: primaryColor,
          colorLinkHover: primaryColor,
        },
        InputNumber: {
          colorBgContainer: 'transprent',
          colorBorder: colors.color_light_1,
        },
        Tooltip: {
          colorBgSpotlight: 'rgba(0,0,0,0.8)',
        },
        Menu: {
          itemBg: colors.background_color_lightdark,
          itemHoverBg: colors.color_light_05,
          itemActiveBg: colors.color_light_1,
          itemSelectedBg: hexToRGBA(primaryColor, 0.1),
          itemSelectedColor: primaryColor,
        },
        Checkbox: {
          colorBgContainer: 'transprent',
        },
        DatePicker: {
          colorBgContainer: 'transprent',
        },
        Modal: {
          contentBg: colors.background_color_lightdark,
          headerBg: colors.background_color_lightdark,
        },
        Radio: {
          buttonBg: 'transprent',
        }
      },
    };
  } else {
    return {
      ...baseTheme,
      token: {
        colorPrimary: primaryColor,
        borderRadius,
        Layout: {
          headerBg: '#fff',
          siderBg: '#fff',
          triggerBg: '#fff',
          algorithm: false, // 启用算法
        },
        Card: {
          colorBgContainer: '#fff',
        },
        Button: {
          colorLink: primaryColor,
          defaultGhostColor: '#fff',
          defaultGhostBorderColor: '#fff',
        },
        Table: {
          colorLink: primaryColor,
          colorPrimary: primaryColor,
        },
        Typography: {
          colorLink: primaryColor,
          colorPrimary: primaryColor,
          colorLinkHover: hexToRGBA(primaryColor, 0.8),
          colorLinkActive: primaryColor,
        },
        Input: {
          colorBgContainer: '#fff',
          colorBorder: '#d9d9d9',
        },
        Tooltip: {
          colorBgSpotlight: 'rgba(0, 0, 0, 0.8)',
        },
        Checkbox: {
          colorBgContainer: '#fff',
        },
        Select: {
          colorBgContainer: '#fff',
          colorBgElevated: '#fff',
          optionSelectedBg: '#e6f4ff',
        },
        InputNumber: {
          colorBgContainer: '#fff',
          addonBg: '#fff',
        },
        DatePicker: {
          colorBgContainer: '#fff',
        },
        Modal: {
          contentBg: '#fff',
          headerBg: '#fff',
        },
        Dropdown: {
          colorBgElevated: '#fff',
        },
        Radio: {
          buttonBg: '#fff',
        }
      },
    };
  }
};
export const SettingContextProvider = ({ children }) => {
  const [dark, setDark] = useLocalStorage('dark', 'true');
  const [primaryColor, setPrimaryColor] = useLocalStorage('primaryColor', '#009ccd');
  const [borderRadius, setBorderRadius] = useLocalStorage('borderRadius', 6);

  const defaultValue = {
    dark,
    setDark,
    primaryColor,
    setPrimaryColor,
    borderRadius,
    setBorderRadius,
  };

  return (
    <SettingContext.Provider value={defaultValue}>
      <ConfigProvider theme={apptheme({ dark, primaryColor, borderRadius })}>{children}</ConfigProvider>
    </SettingContext.Provider>
  );
};

export default SettingContext;
